import styled from 'styled-components';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { RotowireSmallLogo } from '@sorare/core/src/atoms/icons/RotowireLogo';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Cost } from '@sorare/core/src/components/player/Cost';

type Props = {
  so5FixtureEvent: So5FixtureEvent;
};

const RotowireLabel = styled.span`
  font-size: var(--unit);
  font-weight: bold;
  line-height: 1;
  color: var(--c-white);
`;

const projectionScoreLabels = {
  [So5FixtureEvent.CLASSIC]: 'PRO',
  [So5FixtureEvent.DAILY]: 'DH',
  [So5FixtureEvent.RANDOMIZED]: undefined,
  [So5FixtureEvent.MEDIA_LEAGUE]: undefined,
};

export const ProjectionScoreIcon = ({ so5FixtureEvent }: Props) => {
  const inverted = so5FixtureEvent === So5FixtureEvent.DAILY;

  if (!projectionScoreLabels[so5FixtureEvent]) return null;
  return (
    <Cost
      size={3}
      color="var(--c-rotowire)"
      score={
        <Vertical gap={0} center>
          <RotowireSmallLogo size={1} />
          <RotowireLabel>
            {projectionScoreLabels[so5FixtureEvent]}
          </RotowireLabel>
        </Vertical>
      }
      inverted={inverted}
    />
  );
};
